"use client";
import React, { useEffect, useRef, useState } from "react";
import { useModal } from "../Modal/ModalContext";
import QRCodeForm from "../QRCodeForm";
import {
  ALERT_TYPES,
  TRANSACTION_OPTIONS,
  WALLET_TYPES,
  WALLETS,
} from "../../utils/Enum";
import {
  AuthContainer,
  ButtonRow,
  CalloutText,
  CalloutTitle,
  Card,
  CardTitle,
  CheckboxLabel,
  CheckboxWrapper,
  Container,
  DescText,
  Divider,
  DynamicContainer,
  FormWrap,
  HelperText,
  HighlightValue,
  IndicatorCircle,
  IndicatorLine,
  InfoCallout,
  Input,
  InputGroup,
  OptionCard,
  OptionDesc,
  OptionHeader,
  OptionRadio,
  OptionRadioInner,
  OptionTitle,
  PrivateKeyValue,
  SecondaryButton,
  SelectionGrid,
  SplitWrapper,
  StepIndicatorGroup,
  SubmitButton,
  SuccessCheckCircle,
  SummaryBox,
  ToastContainer,
  ToastMessage,
  ToastTitle,
  ToggleButton,
  ToggleButtonGroup,
  VideoBg,
  WarningCallout,
  WizardWrapper,
} from "./SignUpElements";
import axiosInstance from "../Authorization/client";
import { Button, CustomButton, HoverOption } from "../ButtonElement";
import AppBanner from "../AppBanner";
import { XummApp } from "../AppBanner/Data";
import OptionModal from "../OptionModal";
import xummLogo from "../../images/xumm_app_logo.png";
import walletConnectLogo from "../../images/wallet_connect_logo.jpg";
import crossmarkLogo from "../../images/crossmark_wallet_logo.png";
import gemWalletLogo from "../../images/gem_wallet_logo.png";
import joeyWalletLogo from "../../images/joey_wallet_logo.png";
import LoadingScreen, { ModalLoadingScreen } from "../LoadingScreen";
import { useWebsiteTheme } from "../WebsiteTheme/WebsiteThemeContext";
import { useAlert } from "../Alert/AlertContext";
import {
  Form,
  FormButton,
  FormButton1,
  FormContent,
  FormContent1,
  FormGroup,
  FormH1,
  FormInput,
  FormInput1,
  FormLabel,
  FormText,
  FormWrapper,
} from "../CustomForm/CustomFormElements";
import {
  MenuButtonContent,
  MenuButtonDescription,
  MenuButtonIconWrapper,
  MenuButtonTitle,
  MenuGrid,
  MenuImage,
  MenuItemButton,
} from "../MenuOptions/MenuOptionsElements";
import {
  QrCode,
  QrWrapper,
  Small,
  Text,
  TextLink,
  TextRoute,
} from "../QRCodeForm/QrCodeFormElements";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MdEmail, MdWallet } from "react-icons/md";
import { getObjectLength } from "../../utils";
import { emailRegex } from "../../utils/Regex";
import sdk from "@crossmarkio/sdk";
import { useJoeyWallet } from "../../hooks/xrplAppKit/joeyWallet/JoeyWalletProvider";
import { useAuth } from "../../contexts/AuthContext";
import {
  JoeySendTransaction,
  XRPLSendTransaction,
} from "../QRCodeForm/WalletConnect/XRPLSendTransaction";
import { ContentWrapper } from "../../styles/main";
import { useUser } from "../../hooks/useUser";
import { getAddress, isInstalled, signTransaction } from "@gemwallet/api";
import {
  getSignTxStatus,
  updateSignTxStatus,
} from "../../utils/dbUtils/signTxUtils";
import { useXRPLWalletConnect } from "../../hooks/xrplAppKit/XRPLWalletProvider";
import { hashEmail } from "../GravatarAPI";
import Websocket from "react-websocket";
import ScrollToTop from "../ScrollToTop";
import { signInWithCustomToken } from "firebase/auth";
import { auth } from "../Authorization/firebase";

const axios = axiosInstance;

const Web3Registration = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const walletParam = searchParams.get("wallet");
  const [selectedWallet, setSelectedWallet] = useState(walletParam);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 3. Sync state if the URL changes (e.g., browser back/forward buttons)
  /* useEffect(() => {
    if (walletParam !== selectedWallet) {
      setSelectedWallet(walletParam);
    }
  }, [walletParam, selectedWallet]); */

  // 4. Update both state and URL when a wallet is selected or cleared
  const handleWalletSelect = (walletId) => {
    setSelectedWallet(walletId);
    /* if (walletId) {
      setSearchParams({ wallet: walletId });
    } else {
      setSearchParams({}); // Clears the param to show the selector
    } */
  };

  // Map logos to IDs to avoid index errors when filtering
  const walletLogos = {
    [WALLET_TYPES.XAMAN]: xummLogo,
    [WALLET_TYPES.WALLET_CONNECT]: walletConnectLogo,
    [WALLET_TYPES.GEM_WALLET]: gemWalletLogo,
    [WALLET_TYPES.CROSSMARK]: crossmarkLogo,
    [WALLET_TYPES.JOEY_WALLET]: joeyWalletLogo,
  };

  // 2. Filter logic: Only Xaman and WalletConnect for mobile/tablets
  const availableWallets = isSmallScreen
    ? WALLETS.filter(
        (w) =>
          w.id === WALLET_TYPES.XAMAN || w.id === WALLET_TYPES.WALLET_CONNECT,
      )
    : WALLETS;

  if (!selectedWallet) {
    return (
      <FormWrap>
        <FormContent1>
          <Form onSubmit={(e) => e.preventDefault()}>
            <FormH1> Choose your Wallet </FormH1>
            <FormText>
              Select your preferred wallet to begin the registration process.
            </FormText>

            <MenuGrid
              style={{
                gridTemplateColumns: isSmallScreen ? "1fr" : "repeat(2, 1fr)",
                padding: "2%",
              }}
            >
              {availableWallets.map((wallet) => (
                <MenuItemButton
                  key={wallet.id}
                  onClick={() => {
                    handleWalletSelect(wallet.id);
                  }}
                >
                  <MenuButtonIconWrapper>
                    <MenuImage
                      style={{ borderRadius: "50%" }}
                      src={walletLogos[wallet.id]}
                    />
                  </MenuButtonIconWrapper>
                  <MenuButtonContent>
                    <MenuButtonTitle>{wallet.name}</MenuButtonTitle>

                    {/* 3. Hide descriptions on small screens */}
                    {!isSmallScreen && (
                      <MenuButtonDescription>
                        {wallet.description}
                      </MenuButtonDescription>
                    )}
                  </MenuButtonContent>
                </MenuItemButton>
              ))}
            </MenuGrid>
            <Small>
              New to web3 or the XRPL? Learn more about how to sign up{" "}
              <TextRoute to="/faq"> here</TextRoute>
            </Small>
            <Small>
              Already have an account?{" "}
              <TextRoute to="/signin">Sign in</TextRoute>
            </Small>
          </Form>
        </FormContent1>
      </FormWrap>
    );
  }
  return (
    <>
      {selectedWallet === WALLET_TYPES.XAMAN && (
        <XamanRegistration onCancel={() => navigate(-1, { replace: true })} />
      )}
      {selectedWallet === WALLET_TYPES.WALLET_CONNECT && (
        <WalletConnectRegistration
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
      {selectedWallet === WALLET_TYPES.JOEY_WALLET && (
        <JoeyWalletRegistration
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
      {selectedWallet === WALLET_TYPES.GEM_WALLET && (
        <GemWalletRegistration
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
      {selectedWallet === WALLET_TYPES.CROSSMARK && (
        <CrossMarkRegistration
          onCancel={() => navigate(-1, { replace: true })}
        />
      )}
    </>
  );
};

const SignUpTypeSelector = ({ handleSignUpType }) => {
  const navigate = useNavigate();
  const {addAlert} = useAlert()
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 4. Update both state and URL when a wallet is selected or cleared

  return (
    <Form onSubmit={(e) => e.preventDefault()} style={{ alignSelf: "center" }}>
      <MenuGrid
        style={{
          gridTemplateColumns: "repeat(3, 1fr)",
          padding: "2%",
        }}
      >
        <MenuItemButton
          key={"emailPass"}
          onClick={() => {
            /* handleSignUpType("email"); */
            addAlert({ type: ALERT_TYPES.INFO, title: "Coming Soon", secs: 10 });
          }}
        >
          <MenuButtonIconWrapper>
            <MdEmail />
          </MenuButtonIconWrapper>
          <MenuButtonContent>
            <MenuButtonTitle>Email Registration</MenuButtonTitle>

            <MenuButtonDescription>
              {
                "Create a traditional profile using your email credentials. Perfect for accessing your dashboard from any mobile or desktop browser using standard credential managers."
              }
            </MenuButtonDescription>
          </MenuButtonContent>
        </MenuItemButton>
        {/* Visual Structural Separator */}
        <Divider>OR</Divider>
        <MenuItemButton
          key={"Web3"}
          onClick={() => {
            /* handleSignUpType("web3"); */
            addAlert({ type: ALERT_TYPES.INFO, title: "Coming Soon", secs: 10 });
          }}
        >
          <MenuButtonIconWrapper>
            <MdWallet />
          </MenuButtonIconWrapper>
          <MenuButtonContent>
            <MenuButtonTitle>Web3 Registration</MenuButtonTitle>

            <MenuButtonDescription>
              {
                "Authenticate securely using your crypto wallet. Enjoy an entirely passwordless experience, direct on-chain ownership initialization, and native marketplace interactions."
              }
            </MenuButtonDescription>
          </MenuButtonContent>
        </MenuItemButton>
      </MenuGrid>
    </Form>
  );
};

const SignUpPage = ({ onEmailSignUp, onWalletSignUp }) => {
  const { themeColors } = useWebsiteTheme();

  const [next, setNext] = useState(false);

  const [signType, setSignType] = useState();

  return (
    <AuthContainer>
      <FormH1 style={{ textAlign: "center" }}>Join Swerl</FormH1>

      {!signType && (
        <>
          <FormText
            style={{ textAlign: "center", color: themeColors.accentColor }}
          >
            Choose your preferred gateway to the next-gen payment ecosystem.
          </FormText>

          <SignUpTypeSelector handleSignUpType={setSignType} />
        </>
      )}
      {signType === "email" && (
        <>
          <EmailPasswordRegistration />
        </>
      )}
      {signType === "web3" && (
        <>
          {/* Track 2: Web3 Crypto Wallet Sign Up */}
          {!next && (
            <Form>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <FormH1 style={{ fontSize: "1.5rem", marginBottom: "10px" }}>
                    Web3 Identity
                  </FormH1>
                </div>

                <div>
                  <div
                    style={{
                      background: `${themeColors.warningColor}15`,
                      borderLeft: `4px solid ${themeColors.warningColor}`,
                      padding: "12px",
                      borderRadius: "4px",
                      marginBottom: "25px",
                    }}
                  >
                    <FormText
                      style={{
                        fontSize: "0.85rem",
                        fontWeight: "bold",
                        color: themeColors.secondaryBg,
                      }}
                    >
                      Requirements Note:
                    </FormText>
                    <FormText style={{ fontSize: "0.85rem", marginTop: "4px" }}>
                      You must have an{" "}
                      <strong>active, funded crypto wallet </strong> (like
                      Xaman, Gem Wallet, CrossMark, or Wallet Connect) installed
                      on your browser to complete initialization signatures.
                      Unfunded accounts cannot verify identity signatures
                      on-chain.
                    </FormText>
                  </div>
                </div>
              </div>
              <SubmitButton
                onClick={() => {
                  setNext(true);
                }}
              >
                Continue
              </SubmitButton>
            </Form>
          )}
          {next && <Web3Registration />}
        </>
      )}
    </AuthContainer>
  );
};

const EmailPasswordRegistration = ({ onCancel }) => {
  const { themeColors } = useWebsiteTheme();
  const { goTo } = ScrollToTop();
  const [step, setStep] = useState(1); // 1: Credentials, 2: Wallet Setup, 3: Completed
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // Wallet Selection State
  const [walletChoice, setWalletChoice] = useState("generate"); // 'generate', 'link', 'skip'
  const [existingAddress, setExistingAddress] = useState("");
  const [generateType, setGenerateType] = useState("custodial"); // 'custodial', 'self'
  const [isConfirmedUnique, setIsConfirmedUnique] = useState(false);
  const [generatedWalletData, setGeneratedWalletData] = useState(null);

  // Simulation Status
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const triggerToast = (title, message, type = "success") => {
    setNotification({ title, message, type });
    setTimeout(() => setNotification(null), 5000);
  };

  // Step 1: Submit Credentials
  const handleRegisterCredentials = (e) => {
    e.preventDefault();
    if (!email || !password || !confirmPassword) {
      triggerToast(
        "Missing Fields",
        "Please complete all registration parameters.",
        "error",
      );
      return;
    }
    if (password !== confirmPassword) {
      triggerToast(
        "Passwords Mismatch",
        "The entered passwords do not match. Please verify.",
        "error",
      );
      return;
    }

    setLoading(true);
    // Simulate API registration call
    setTimeout(() => {
      setLoading(false);
      triggerToast(
        "Credentials Verified",
        "Account created! Now, let's configure your wallet strategy.",
        "success",
      );
      setStep(2);
    }, 1200);
  };

  // Step 2: Process Selected Wallet Strategy
  const handleWalletSetup = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);

      if (walletChoice === "generate") {
        const mockAddress =
          "rSwerlOnChain" +
          Math.random().toString(36).substring(2, 10).toUpperCase();
        const mockSecret =
          "sEdV" + Math.random().toString(36).substring(2, 12).toUpperCase();

        setGeneratedWalletData({
          address: mockAddress,
          secret:
            generateType === "self"
              ? mockSecret
              : "Secured by Swerl HSM System",
          type: generateType,
        });

        triggerToast(
          "Wallet Configured",
          `Successfully generated your Swerl \${generateType} wallet.`,
          "success",
        );
        setStep(3);
      } else if (walletChoice === "link") {
        if (!existingAddress) {
          triggerToast(
            "Missing Address",
            "Please enter your classic XRPL address to continue.",
            "error",
          );
          return;
        }
        if (!isConfirmedUnique) {
          triggerToast(
            "Confirmation Required",
            "Please verify and check the box confirming this address is not linked to another profile.",
            "warning",
          );
          return;
        }

        triggerToast(
          "Wallet Connected",
          "Existing XRPL wallet verified and associated with your Swerl account.",
          "success",
        );
        setStep(3);
      } else {
        // Skip path
        triggerToast(
          "Profile Activated",
          "Skip confirmed. Your account will default to PayFast/Paystack card options.",
          "success",
        );
        setStep(3);
      }
    }, 1500);
  };

  return (
    <>
      {notification && (
        <ToastContainer type={notification.type}>
          <ToastTitle type={notification.type}>{notification.title}</ToastTitle>
          <ToastMessage>{notification.message}</ToastMessage>
        </ToastContainer>
      )}

      <Card>
        <StepIndicatorGroup>
          <IndicatorCircle active={step === 1} completed={step > 1}>
            1
          </IndicatorCircle>
          <IndicatorLine completed={step > 1} />
          <IndicatorCircle active={step === 2} completed={step > 2}>
            2
          </IndicatorCircle>
          <IndicatorLine completed={step > 2} />
          <IndicatorCircle active={step === 3} completed={false}>
            3
          </IndicatorCircle>
        </StepIndicatorGroup>

        {step === 1 && (
          <form onSubmit={handleRegisterCredentials}>
            <CardTitle>Create Your Account</CardTitle>
            <DescText>
              Join Swerl to start supporting your favorite independent music
              artists through real-time micropayments.
            </DescText>

            <FormGroup>
              <FormLabel>Email Address</FormLabel>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Choose Password</FormLabel>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••••"
                required
              />
            </FormGroup>

            <FormGroup>
              <FormLabel>Confirm Password</FormLabel>
              <Input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••••••"
                required
              />
            </FormGroup>

            <SubmitButton type="submit" disabled={loading}>
              {loading ? "Creating Profile..." : "Sign Up with Email"}
            </SubmitButton>
            <CustomButton disabled={loading}>Cancel</CustomButton>
          </form>
        )}

        {step === 2 && (
          <div>
            <CardTitle>Configure Streaming Wallet</CardTitle>
            <DescText>
              Swerl uses the XRP Ledger (XRPL) to facilitate instant, real-time
              micropayments directly to artists. Tell us how you'd like to fund
              your streams.
            </DescText>

            <InfoCallout>
              <CalloutTitle>Why do I need a wallet?</CalloutTitle>
              <CalloutText>
                Your XRPL wallet address handles streaming micro-royalties,
                digital album/collectible purchases, and secure storage of
                subscription assets. If you sign up on the Sonar Muse platform
                using these Swerl credentials, your wallet address will be
                automatically mapped to your profile.
              </CalloutText>
            </InfoCallout>

            <SelectionGrid>
              <OptionCard
                active={walletChoice === "generate"}
                onClick={() => setWalletChoice("generate")}
              >
                <OptionHeader>
                  <OptionRadio active={walletChoice === "generate"}>
                    {walletChoice === "generate" && <OptionRadioInner />}
                  </OptionRadio>
                  <OptionTitle>Generate a Swerl Smart Wallet</OptionTitle>
                </OptionHeader>
                <OptionDesc>
                  We'll create a new secure XRPL address for you. You can export
                  your private keys to cold storage at any time.
                </OptionDesc>
              </OptionCard>

              <OptionCard
                active={walletChoice === "link"}
                onClick={() => setWalletChoice("link")}
              >
                <OptionHeader>
                  <OptionRadio active={walletChoice === "link"}>
                    {walletChoice === "link" && <OptionRadioInner />}
                  </OptionRadio>
                  <OptionTitle>Link My Own XRP Wallet</OptionTitle>
                </OptionHeader>
                <OptionDesc>
                  Map an existing classic XRPL address (e.g. from Xaman, Gem
                  Wallet, or CrossMark).
                </OptionDesc>
              </OptionCard>

              <OptionCard
                active={walletChoice === "skip"}
                onClick={() => setWalletChoice("skip")}
              >
                <OptionHeader>
                  <OptionRadio active={walletChoice === "skip"}>
                    {walletChoice === "skip" && <OptionRadioInner />}
                  </OptionRadio>
                  <OptionTitle>Skip For Now (Pay with Credit Card)</OptionTitle>
                </OptionHeader>
                <OptionDesc>
                  Do not configure a wallet now. You can load play-time balances
                  using standard card checkouts on the platform dashboard.
                </OptionDesc>
              </OptionCard>
            </SelectionGrid>

            {walletChoice === "generate" && (
              <DynamicContainer>
                <FormLabel>Custody Management Style</FormLabel>
                <ToggleButtonGroup>
                  <ToggleButton
                    active={generateType === "custodial"}
                    onClick={() => setGenerateType("custodial")}
                  >
                    Custodial (Simple)
                  </ToggleButton>
                  <ToggleButton
                    active={generateType === "self"}
                    onClick={() => setGenerateType("self")}
                  >
                    Self-Custody (Export Secret)
                  </ToggleButton>
                </ToggleButtonGroup>
                <HelperText>
                  {generateType === "custodial"
                    ? "✓ Keys are secured within Swerl HSM systems. No setup required. 5 XRP activation fee applies upon deposit."
                    : "⚠️ You will get access to the generated secret key. We do not store this key, so make sure to copy and save it securely!"}
                </HelperText>
              </DynamicContainer>
            )}

            {walletChoice === "link" && (
              <DynamicContainer>
                <FormGroup>
                  <FormLabel>Classic XRP Wallet Address (R-Address)</FormLabel>
                  <Input
                    type="text"
                    monospace
                    value={existingAddress}
                    onChange={(e) => setExistingAddress(e.target.value)}
                    placeholder="e.g. rSwErL1n6PaYt1CkpXvR..."
                  />
                </FormGroup>

                <WarningCallout>
                  <CalloutTitle style={{ color: themeColors.errorColor }}>
                    Uniqueness Restriction
                  </CalloutTitle>
                  <CalloutText>
                    Before completing registration, ensure this address is not
                    linked to any other Swerl or Sonar Muse profiles. Linking an
                    address already in use on our ledger will trigger a
                    validation error.
                  </CalloutText>
                </WarningCallout>

                <CheckboxWrapper>
                  <input
                    type="checkbox"
                    id="confirmUnique"
                    checked={isConfirmedUnique}
                    onChange={(e) => setIsConfirmedUnique(e.target.checked)}
                    style={{ marginTop: "4px", cursor: "pointer" }}
                  />
                  <CheckboxLabel htmlFor="confirmUnique">
                    I confirm that this XRPL wallet address is unique and not
                    associated with any other account.
                  </CheckboxLabel>
                </CheckboxWrapper>
              </DynamicContainer>
            )}

            {walletChoice === "skip" && (
              <InfoCallout
                borderColor={themeColors.warningColor}
                style={{ backgroundColor: "rgba(255, 183, 77, 0.03)" }}
              >
                <CalloutTitle style={{ color: themeColors.warningColor }}>
                  Proceeding with standard card billing
                </CalloutTitle>
                <CalloutText>
                  No problem! You can load play-time credits using card and
                  other supported payment methods. You can also generate or map
                  an XRPL wallet at any time directly through your dashboard
                  settings.
                </CalloutText>
              </InfoCallout>
            )}

            <ButtonRow>
              <SecondaryButton onClick={() => setStep(1)}>Back</SecondaryButton>
              <SubmitButton
                onClick={handleWalletSetup}
                disabled={loading}
                style={{ flex: 1 }}
              >
                {loading ? "Processing Choice..." : "Complete Setup & Continue"}
              </SubmitButton>
            </ButtonRow>
          </div>
        )}

        {step === 3 && (
          <div style={{ textAlign: "center" }}>
            <SuccessCheckCircle>✓</SuccessCheckCircle>
            <CardTitle>Welcome to Swerl!</CardTitle>
            <DescText>
              Your account registration and payment setup are complete. You are
              now ready to stream music and support independent artists.
            </DescText>

            {generatedWalletData && (
              <SummaryBox>
                <FormLabel>Your Generated Address</FormLabel>
                <HighlightValue>{generatedWalletData.address}</HighlightValue>

                <FormLabel>Private Key status</FormLabel>
                <PrivateKeyValue>{generatedWalletData.secret}</PrivateKeyValue>

                {generatedWalletData.type === "self" && (
                  <span
                    style={{
                      fontSize: "10px",
                      color: themeColors.warningColor,
                      display: "block",
                      marginTop: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⚠️ Back up this secret immediately. It cannot be recovered
                    if lost.
                  </span>
                )}
              </SummaryBox>
            )}

            <SubmitButton
              onClick={() => {
                goTo("/home");
              }}
            >
              Go to Dashboard
            </SubmitButton>
          </div>
        )}
      </Card>
    </>
  );
};

const XamanRegistration = ({ onCancel }) => {
  const { toggleModal, modalContent, isOpen, closeModal, openModal } =
    useModal();
  const { validateUser } = useUser({});
  const [email, setEmail] = useState();
  const [invoice, setInvoice] = useState();
  const [status, setStatus] = useState("idle");
  const [response, setResponse] = useState({});
  const [isVLoaded, setVLoaded] = useState(true);
  const [userAddress, setAddress] = useState("");
  const [errMsg, setError] = useState();
  const [emailErr, setEmailError] = useState();
  const [msg, setMessage] = useState("");
  const [isLoaded, setLoaded] = useState(false);
  const [isOpened, setOpened] = useState(false);
  const [payload, setPayload] = useState();
  const [isSigned, setSigned] = useState(false);
  const [next, setNext] = useState(false);
  const [gravatarUrl, setGravatar] = useState();
  const { signup, logout, getGravatarInfo, setEligible, currentUser } =
    useAuth();
  const emailRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (invoice) {
      getSignTxStatus(invoice, status, setStatus, setResponse);
    }
    return () => {};
  }, [invoice]);

  useEffect(() => {
    if (invoice) {
      if (status === "success" && response !== false) {
        VerifySignIn(response);
      }
      if (status === "error") {
        setLoaded(false);
        setPayload();
        setError(
          response?.error
            ? response?.error
            : "The sign in has failed. Reload the page and try again",
        );
      }
    }
    return () => {};
  }, [status, invoice]);

  function handleInput(e) {
    setError();
    setEmail(e?.target.value);
    setEmailError();
    //emailRef.curr
    //console.log(emailRef.current.value)
    //console.log(hashEmail(e.target.value))
  }

  const updateSignInStatus = async (messageData) => {
    //console.log('Message Data: ', messageData)
    const data = JSON.parse(messageData);
    if (data.opened === true) {
      setOpened(true);
      setMessage("Wating for you to sign transaction");
      return;
    }
    if (isOpened === true && data.signed === true) {
      //VerifySignIn(payload.uuid);
      setLoaded(false);
      setError();
      setStatus("loading");
      return;
      //console.log("Signed")
    } else if (isOpened === true && data.signed === false) {
      setLoaded(false);
      setPayload({});
      setError("The transaction was rejected. Reload the page and try again");
      return;
    }
    if (data?.expired === true) {
      setLoaded(false);
      setPayload();
      setError("The transaction has expired. Reload the page and try again");
      setOpened(false);
    }
    if (data?.signed === false) {
      setLoaded(false);
      setPayload();
      setError("The transaction was rejected. Reload the page and try again");
      setOpened(false);
    }
  };

  //Verify xumm payload sign in by user
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async (response) => {
    setVLoaded(false);
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    setEmailError();
    setEmail();

     signInWithCustomToken(auth, response.token)
                .then((user) => {
                      navigate( "/home");
                })
                .catch((err) => {
                  //console.log(err);
                  setEmailError(err.message);
                  setVLoaded(true);
                }); 
  // navigate('/home')
    return;
  };

  const setAccount = async () => {
    return axios
      .post("/api/userSignUp", {
        email: email,
        userToken: localStorage.getItem("userToken"),
        type: TRANSACTION_OPTIONS.SIGN_UP,
        txInfo: {
          email: email,
        },
      })
      .then((res) => {
        setPayload(res.data.payload);
        setInvoice(res.data.invoice);
        setLoaded(true);
      })
      .catch((err) => {
        console.error(err);
        setError("Oops! Something wrong happened. Reload the page");
        setLoaded();
      });
  };

  const validateEmail = async () => {
    toggleModal();
    modalContent(<ModalLoadingScreen text={"Loading. Please Wait"} />);
    return axios
      .get(`/api/${hashEmail(email)}/validateUser`)
      .then((valid) => {
        if (!valid?.data?.exists) {
          modalContent(
            <OptionModal
              heading={"Continue with Registration?"}
              additionalText={`Clicking continue will direct you to signing a transaction which will link the following email address ${email} to your XRP wallet address.
        In order to access the platform in the future, this email address will have to be linked to the wallet address you sign up with `}
            >
              <HoverOption
                onClick={() => {
                  setAccount();
                  setNext(true);
                  closeModal();
                  modalContent();
                }}
              >
                Continue
              </HoverOption>
            </OptionModal>,
          );
        } else {
          setEmail();
          modalContent(
            <OptionModal
              heading={"Email Address Already Exists"}
              additionalText={
                "An account with this email address already exists. Please enter a different email address or Login"
              }
            >
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                }}
              >
                OK
              </HoverOption>
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                  navigate("/signin");
                }}
              >
                Login
              </HoverOption>
            </OptionModal>,
          );
        }
      })
      .catch((err) => {
        console.error(err);
        modalContent(
          <OptionModal heading={"Something went wrong"}>
            <HoverOption
              onclick={() => {
                validateEmail();
              }}
            >
              Try Again
            </HoverOption>
          </OptionModal>,
        );
      });
  };

  const validateTx = async () => {
    setLoaded(false);
    return await axios
      .post("/api/verifyTxPayload", { uuid: payload?.uuid })
      .then((verification) => {
        //console.log(verification)
        if (verification?.data && !verification?.data?.error) {
          setLoaded(false);
          //dispatch(verification?.data);
          getSignTxStatus(invoice, status, setStatus, setResponse);
          setSigned(true);
          setPayload();
          setError("The transaction went through successfully.");
          setOpened(false); //console.log("Signed")
          return;
        } else {
          setSigned(false);
          setLoaded(true);
          setError("The transaction was not signed.");
          return;
        }
      })
      .catch((err) => {
        console.error(err);
        setSigned(false);
        setLoaded(true);
        setError("Something went wrong. Try again");
      });
  };

  const refreshPage = () => {
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    setAccount();
  };

  useEffect(() => {
     if (currentUser?.uid) {
      navigate("/home");
    }else{ 
    setNext(false);
    setLoaded(false);
    setPayload({});
    setOpened(false);
    setError("");}
    return () => {};
  }, []);

  //render the sign up forms
  return (
    <>
      
          {!next && (
            <FormWrap>
              <Card>
                
                  <FormGroup>
                    <FormLabel>Email Address</FormLabel>
                    <Input
                      onChange={handleInput}
                      placeholder="Email Address"
                      value={email}
                    />
                    <Small>
                      Note: This address will be linked to your XRP wallet
                      address
                    </Small>
                  </FormGroup>
                  {emailErr && <Text>{emailErr}</Text>}
                  <FormButton1
                    onClick={() => {
                      if (emailRegex.test(email)) {
                        return validateEmail();
                      } else {
                        setEmailError("Invalid email address");
                      }
                    }}
                  >
                    Continue
                  </FormButton1>

                  <Small>
                    New to web3 or the XRPL? Learn more about how to sign up{" "}
                    <TextRoute to="/faq"> here</TextRoute>
                  </Small>
                  <Small>
                    Already have an account?{" "}
                    <TextRoute
                      to="/signin"
                      onClick={() => {
                        toggleModal();
                      }}
                    >
                      Sign in
                    </TextRoute>
                  </Small>
                
              </Card>
            </FormWrap>
          )}

          {next && (
            <>
              {" "}
              {isLoaded === true && getObjectLength(payload) > 0 && (
                <>
                  <Websocket
                    url={payload.refs.websocket_status}
                    onMessage={(data) => updateSignInStatus(data)}
                  />
                  <FormWrap>
                    <FormContent1>
                      <Form>
                        <FormH1> Sign Up </FormH1>
                        <QrWrapper href={payload.next.always}>
                          <QrCode src={payload.refs.qr_png} />
                        </QrWrapper>
                        {isOpened === false && (
                          <Text>
                            Scan QR code or click{" "}
                            <TextLink
                              href={payload.next.always}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              here
                            </TextLink>{" "}
                            to go to your Xumm wallet
                          </Text>
                        )}
                        {isOpened === true && (
                          <Text>
                            <Text>{msg}</Text>
                          </Text>
                        )}
                        <FormButton1 onClick={() => validateTx()} transparent>
                          I Already Signed Transaction
                        </FormButton1>
                        <FormButton
                          transparent={false}
                          to="/signup"
                          onClick={refreshPage}
                        >
                          Reload
                        </FormButton>
                        <Small>
                          New to web3 or the XRPL? Learn more about how to sign
                          up <TextRoute to="/faq"> here</TextRoute>
                        </Small>
                        <Small>
                          Already have an account?{" "}
                          <TextRoute to="#">Sign in</TextRoute>
                        </Small>{" "}
                      </Form>
                    </FormContent1>
                  </FormWrap>
                </>
              )}
              {errMsg && !response?.error && (
                <FormWrap>
                  
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1
                        transparent={false}
                        to="/access/signup"
                        onClick={refreshPage}
                      >
                        Reload
                      </FormButton1>
                    </Form>
                  
                </FormWrap>
              )}
              {errMsg && response?.error && (
                <FormWrap>
                  <Card>
                    
                      <Text>{errMsg}</Text>
                      <FormButton1
                        transparent={false}
                        to="/access/signup"
                        onClick={() => {
                          setEmail();
                          setEmailError();
                          setNext(false);
                          setLoaded(false);
                          setPayload({});
                          setError();
                          setInvoice();
                          setStatus("idle");
                          setResponse();
                          setOpened(false);
                          setLoaded(false);
                        }}
                      >
                        Retry
                      </FormButton1>
                      <FormButton1 onClick={() => navigate("/")}>
                        Go Home
                      </FormButton1>
                    
                  </Card>
                </FormWrap>
              )}
              {!errMsg && !isLoaded && (
                <LoadingScreen
                  text={"Loading. Please Wait..."}
                  transparent={true}
                  isLoaded={isLoaded}
                />
              )}
            </>
          )}
    </>
  );
};

const WalletConnectRegistration = ({ onCancel }) => {
  const {
    session,
    setSession,
    account,
    setAccount,
    disconnect,
    connect,
    isReady,
  } = useXRPLWalletConnect();
  const { toggleModal, modalContent, isOpen, closeModal, openModal } =
    useModal();
  const { validateUser } = useUser({});
  const [email, setEmail] = useState();
  const [invoice, setInvoice] = useState();
  const [status, setStatus] = useState("idle");
  const [response, setResponse] = useState({});
  const [isVLoaded, setVLoaded] = useState(true);
  const [errMsg, setError] = useState();
  const [emailErr, setEmailError] = useState();
  const [isLoaded, setLoaded] = useState(false);
  const [isOpened, setOpened] = useState(false);
  const [payload, setPayload] = useState();
  const [next, setNext] = useState(false);
  const { currentUser } = useAuth();
  const emailRef = useRef();
  const navigate = useNavigate();

  function handleInput(e) {
    setError();
    setEmail(e?.target.value);
    setEmailError();
    //emailRef.curr
    //console.log(emailRef.current.value)
    //console.log(hashEmail(e.target.value))
  }

  //Verify xumm payload sign in by user
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async (response) => {
    setVLoaded(false);
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    setEmailError();
    setEmail();
    disconnect();
    /*  signInWithCustomToken(auth, response.token)
                .then((user) => {
                      navigate( "/home");
                })
                .catch((err) => {
                  //console.log(err);
                  setEmailError(err.message);
                  setVLoaded(true);
                }); */
    openModal();
    modalContent(
      <OptionModal
        heading={"Registration Successful"}
        additionalText={
          "Your wallet address has successfully signed up for the sonar muse platform."
        }
      >
        <HoverOption
          onClick={() => {
            navigate("/access/signin");
            closeModal();
            modalContent();
          }}
        >
          Sign In
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/store");
            closeModal();
            modalContent();
          }}
        >
          Music Store
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/eligibilityChecker");
            closeModal();
            modalContent();
          }}
        >
          Check Eligibility Status
        </HoverOption>
      </OptionModal>,
    );
    return;
  };

  /*  const setAccount = async () => {
   return axios
      .post("/api/userSignUp", {
        email: email,
        userToken: localStorage.getItem("userToken"),
        type: TRANSACTION_OPTIONS.SIGN_UP,
        txInfo: {
          email: email
        },
      })
      .then((res) => {
        setPayload(res.data.payload);
        setInvoice(res.data.invoice)
        setLoaded(true);
      })
      .catch((err) => {
        console.error(err);
        setError("Oops! Something wrong happened. Reload the page");
        setLoaded();
      });
  }; */

  const validateEmail = async () => {
    toggleModal();
    modalContent(<ModalLoadingScreen text={"Loading. Please Wait"} />);
    return axios
      .get(`/api/${hashEmail(email)}/validateUser`)
      .then((valid) => {
        if (!valid?.data?.exists) {
          modalContent(
            <OptionModal
              heading={"Continue with Registration?"}
              additionalText={`Clicking continue will direct you to signing a transaction which will link the following email address ${email} to your XRP wallet address.
        In order to access the platform in the future, this email address will have to be linked to the wallet address you sign up with `}
            >
              <HoverOption
                onClick={() => {
                  let s = session;
                  modalContent(
                    <ModalLoadingScreen text={"Loading. Please Wait"} />,
                  );
                  return axios
                    .post(`/api/xrpl/createTransaction`, {
                      email: email,
                      type: TRANSACTION_OPTIONS.SIGN_UP,
                      memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                      txInfo: {
                        email: email,
                        memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                        type: TRANSACTION_OPTIONS.SIGN_UP,
                      },
                      sender: s?.namespaces?.xrpl?.accounts[0]?.split(":")[2],
                      walletType: WALLET_TYPES.WALLET_CONNECT,
                    })
                    .then((res) => {
                      // Switch the modal content to the Signer
                      closeModal();
                      modalContent();
                      setPayload(res.data.payload);
                      setInvoice(res.data.invoice);
                      setLoaded(true);
                      setNext(true);
                    })
                    .catch((err) => {
                      console.error(err);
                      setError(
                        "Something went wrong. Please reload and try again",
                      );
                    });
                }}
              >
                Continue
              </HoverOption>
            </OptionModal>,
          );
        } else {
          setEmail();
          modalContent(
            <OptionModal
              heading={"Email Address Already Exists"}
              additionalText={
                "An account with this email address already exists. Please enter a different email address or Login"
              }
            >
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                }}
              >
                OK
              </HoverOption>
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                  navigate("/access/login");
                }}
              >
                Login
              </HoverOption>
            </OptionModal>,
          );
        }
      })
      .catch((err) => {
        console.error(err);
        modalContent(
          <OptionModal heading={"Something went wrong"}>
            <HoverOption
              onclick={() => {
                validateEmail();
              }}
            >
              Try Again
            </HoverOption>
          </OptionModal>,
        );
      });
  };

  const refreshPage = () => {
    localStorage.clear();
    setPayload();
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    setAccount();
    disconnect();
  };

  useEffect(() => {
     if (currentUser?.uid) {
      navigate("/home");
    }else{
    setNext(false);
    setLoaded(false);
    setPayload();
    setOpened(false);
    setError("");}
    return () => {};
  }, []);

  //render the sign up forms
  return (
    <>
          {!session && (
            <>
              <FormWrap>
                <Card>
                    <FormButton1 onClick={() => connect()}>
                      {"Connect Wallet"}
                    </FormButton1>
                    <br />
                    <FormButton1 onClick={() => onCancel()}>
                      {"Cancel"}
                    </FormButton1>
                    <Small>
                      New to web3 or the XRPL? Learn more about how to sign up{" "}
                      <TextRoute to="/faq"> here</TextRoute>
                    </Small>
                    <Small>
                      Already have an account?{" "}
                      <TextRoute to="/access/signIn">Sign in</TextRoute>
                    </Small>
                </Card>
              </FormWrap>
            </>
          )}
          {session && !next && (
            <FormWrap>
              <Card>
                  <FormGroup>
                    <FormLabel>Email Address</FormLabel>
                    <Input
                      onChange={handleInput}
                      placeholder="Email Address"
                      value={email}
                    />
                    <Small>
                      Note: This address will be linked to your XRP wallet
                      address
                    </Small>
                  </FormGroup>
                  {emailErr && <Text>{emailErr}</Text>}
                  <FormButton1
                    onClick={() => {
                      if (emailRegex.test(email)) {
                        return validateEmail();
                      } else {
                        setEmailError("Invalid email address");
                      }
                    }}
                  >
                    Continue
                  </FormButton1>

                  <Small>
                    New to web3 or the XRPL? Learn more about how to sign up{" "}
                    <TextRoute to="/faq"> here</TextRoute>
                  </Small>
                  <Small>
                    Already have an account?{" "}
                    <TextRoute to="/access/signin">Sign in</TextRoute>
                  </Small>
               </Card>
            </FormWrap>
          )}

          {next && (
            <>
              {" "}
              {isLoaded === true && session && getObjectLength(payload) > 0 && (
                <>
                  <XRPLSendTransaction
                    heading={"Sign Up"}
                    payload={payload}
                    topic={session?.topic}
                    account={
                      session?.namespaces?.xrpl?.accounts[0]?.split(":")[2]
                    }
                    invoice={invoice}
                    method={"xrpl_signTransaction"}
                    onSuccess={VerifySignIn}
                    onFail={(value) => {
                      setLoaded(false);
                      setPayload();
                      setResponse(value);
                      setError(
                        "The sign in has failed. Reload the page and try again",
                      );
                    }}
                    cancel={onCancel}
                    body={{
                      email: email,
                      type: TRANSACTION_OPTIONS.SIGN_UP,
                      sender:
                        session?.namespaces?.xrpl?.accounts[0]?.split(":")[2],
                      walletType: WALLET_TYPES.WALLET_CONNECT,
                    }}
                    type={TRANSACTION_OPTIONS.SIGN_UP}
                  />
                </>
              )}
              {errMsg && !response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1 transparent={false} onClick={refreshPage}>
                        Reload
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {errMsg && response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1
                        transparent={false}
                        to="/access/signup"
                        onClick={() => {
                          setEmail();
                          setEmailError();
                          setNext(false);
                          setLoaded(false);
                          setPayload({});
                          setError();
                          setInvoice();
                          setStatus("idle");
                          setResponse();
                          setOpened(false);
                          setLoaded(false);
                        }}
                      >
                        Retry
                      </FormButton1>
                      <FormButton1 onClick={() => navigate("/")}>
                        Go Home
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {!errMsg && !isLoaded && (
                <LoadingScreen
                  text={"Loading. Please Wait..."}
                  transparent={true}
                  isLoaded={isLoaded}
                />
              )}
            </>
          )}
        
    </>
  );
};

const JoeyWalletRegistration = ({ onCancel }) => {
  const {
    session,
    setSession,
    account,
    disconnect,
    connect,
    isReady,
    reconnect,
    actions,
    provider,
  } = useJoeyWallet();
  const { toggleModal, modalContent, isOpen, closeModal, openModal } =
    useModal();
  const [email, setEmail] = useState();
  const [invoice, setInvoice] = useState();
  const [status, setStatus] = useState("idle");
  const [response, setResponse] = useState({});
  const [isVLoaded, setVLoaded] = useState(true);
  const [errMsg, setError] = useState();
  const [emailErr, setEmailError] = useState();
  const [isLoaded, setLoaded] = useState(false);
  const [isOpened, setOpened] = useState(false);
  const [payload, setPayload] = useState();
  const [next, setNext] = useState(false);
  const { currentUser } = useAuth();
  const emailRef = useRef();
  const navigate = useNavigate();

  function handleInput(e) {
    setError();
    setEmail(e?.target.value);
    setEmailError();
    //emailRef.curr
    //console.log(emailRef.current.value)
    //console.log(hashEmail(e.target.value))
  }

  //Verify xumm payload sign in by user
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async (response) => {
    setVLoaded(false);
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    setEmailError();
    setEmail();
    disconnect();
    /*  signInWithCustomToken(auth, response.token)
                .then((user) => {
                      navigate( "/home");
                })
                .catch((err) => {
                  //console.log(err);
                  setEmailError(err.message);
                  setVLoaded(true);
                }); */
    openModal();
    modalContent(
      <OptionModal
        heading={"Registration Successful"}
        additionalText={
          "Your wallet address has successfully signed up for the sonar muse platform."
        }
      >
        <HoverOption
          onClick={() => {
            navigate("/access/signin");
            closeModal();
            modalContent();
          }}
        >
          Sign In
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/store");
            closeModal();
            modalContent();
          }}
        >
          Music Store
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/eligibilityChecker");
            closeModal();
            modalContent();
          }}
        >
          Check Eligibility Status
        </HoverOption>
      </OptionModal>,
    );
    return;
  };

  /*  const setAccount = async () => {
   return axios
      .post("/api/userSignUp", {
        email: email,
        userToken: localStorage.getItem("userToken"),
        type: TRANSACTION_OPTIONS.SIGN_UP,
        txInfo: {
          email: email
        },
      })
      .then((res) => {
        setPayload(res.data.payload);
        setInvoice(res.data.invoice)
        setLoaded(true);
      })
      .catch((err) => {
        console.error(err);
        setError("Oops! Something wrong happened. Reload the page");
        setLoaded();
      });
  }; */

  const validateEmail = async () => {
    toggleModal();
    modalContent(<ModalLoadingScreen text={"Loading. Please Wait"} />);
    return axios
      .get(`/api/${hashEmail(email)}/validateUser`)
      .then((valid) => {
        if (!valid?.data?.exists) {
          modalContent(
            <OptionModal
              heading={"Continue with Registration?"}
              additionalText={`Clicking continue will direct you to signing a transaction which will link the following email address ${email} to your XRP wallet address.
        In order to access the platform in the future, this email address will have to be linked to the wallet address you sign up with `}
            >
              <HoverOption
                onClick={() => {
                  let s = session;
                  modalContent(
                    <ModalLoadingScreen text={"Loading. Please Wait"} />,
                  );
                  return axios
                    .post(`/api/xrpl/createTransaction`, {
                      email: email,
                      type: TRANSACTION_OPTIONS.SIGN_UP,
                      memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                      txInfo: {
                        email: email,
                        memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                        type: TRANSACTION_OPTIONS.SIGN_UP,
                      },
                      sender: s?.namespaces?.xrpl?.accounts[0]?.split(":")[2],
                      walletType: WALLET_TYPES.JOEY_WALLET,
                    })
                    .then((res) => {
                      // Switch the modal content to the Signer
                      closeModal();
                      modalContent();
                      setPayload(res.data.payload);
                      setInvoice(res.data.invoice);
                      setLoaded(true);
                      setNext(true);
                    })
                    .catch((err) => {
                      console.error(err);
                      setError(
                        "Something went wrong. Please reload and try again",
                      );
                    });
                }}
              >
                Continue
              </HoverOption>
            </OptionModal>,
          );
        } else {
          setEmail();
          modalContent(
            <OptionModal
              heading={"Email Address Already Exists"}
              additionalText={
                "An account with this email address already exists. Please enter a different email address or Login"
              }
            >
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                }}
              >
                OK
              </HoverOption>
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                  navigate("/access/login");
                }}
              >
                Login
              </HoverOption>
            </OptionModal>,
          );
        }
      })
      .catch((err) => {
        console.error(err);
        modalContent(
          <OptionModal heading={"Something went wrong"}>
            <HoverOption
              onclick={() => {
                validateEmail();
              }}
            >
              Try Again
            </HoverOption>
          </OptionModal>,
        );
      });
  };

  const refreshPage = () => {
    localStorage.clear();
    setPayload();
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    disconnect();
  };

  useEffect(() => {
     if (currentUser?.uid) {
      navigate("/home");
    }else{
    setNext(false);
    setLoaded(false);
    setPayload();
    setOpened(false);
    setError("");
    return () => {};}
  }, []);

  //render the sign up forms
  return (
    <>
     
          {!session && (
            <>
              <FormWrap>
                <Card>
                    <FormButton1 onClick={() => connect()}>
                      {"Connect Wallet"}
                    </FormButton1>
                    <br />
                    <FormButton1 onClick={() => onCancel()}>
                      {"Cancel"}
                    </FormButton1>
                    <Small>
                      New to web3 or the XRPL? Learn more about how to sign up{" "}
                      <TextRoute to="/faq"> here</TextRoute>
                    </Small>
                    <Small>
                      Already have an account?{" "}
                      <TextRoute to="/access/signIn">Sign in</TextRoute>
                    </Small>
                  </Card>
              </FormWrap>
            </>
          )}
          {session && !next && (
            <FormWrap>
              <Card>
                  <FormGroup>
                    <FormLabel>Email Address</FormLabel>
                    <FormInput
                      onChange={handleInput}
                      placeholder="Email Address"
                      value={email}
                    />
                    <Small>
                      Note: This address will be linked to your XRP wallet
                      address
                    </Small>
                  </FormGroup>
                  {emailErr && <Text>{emailErr}</Text>}
                  <FormButton1
                    onClick={() => {
                      if (emailRegex.test(email)) {
                        return validateEmail();
                      } else {
                        setEmailError("Invalid email address");
                      }
                    }}
                  >
                    Continue
                  </FormButton1>

                  <Small>
                    New to web3 or the XRPL? Learn more about how to sign up{" "}
                    <TextRoute to="/faq"> here</TextRoute>
                  </Small>
                  <Small>
                    Already have an account?{" "}
                    <TextRoute to="/signin">Sign in</TextRoute>
                  </Small>
               </Card>
            </FormWrap>
          )}

          {next && (
            <>
              {" "}
              {isLoaded === true && session && getObjectLength(payload) > 0 && (
                <>
                  <JoeySendTransaction
                    heading={"Sign Up"}
                    payload={payload}
                    topic={session?.topic}
                    account={
                      session?.namespaces?.xrpl?.accounts[0]?.split(":")[2]
                    }
                    invoice={invoice}
                    method={"xrpl_signTransaction"}
                    onSuccess={VerifySignIn}
                    cancel={onCancel}
                    onFail={(value) => {
                      setLoaded(false);
                      setPayload();
                      setResponse(value);
                      setError(
                        "The sign in has failed. Reload the page and try again",
                      );
                    }}
                    body={{
                      email: email,
                      type: TRANSACTION_OPTIONS.SIGN_UP,
                      sender:
                        session?.namespaces?.xrpl?.accounts[0]?.split(":")[2],
                      walletType: WALLET_TYPES.WALLET_CONNECT,
                    }}
                    type={TRANSACTION_OPTIONS.SIGN_UP}
                  />
                </>
              )}
              {errMsg && !response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1 transparent={false} onClick={refreshPage}>
                        Reload
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {errMsg && response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1
                        transparent={false}
                        to="/access/signup"
                        onClick={() => {
                          setEmail();
                          setEmailError();
                          setNext(false);
                          setLoaded(false);
                          setPayload({});
                          setError();
                          setInvoice();
                          setStatus("idle");
                          setResponse();
                          setOpened(false);
                          setLoaded(false);
                        }}
                      >
                        Retry
                      </FormButton1>
                      <FormButton1 onClick={() => navigate("/")}>
                        Go Home
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {!errMsg && !isLoaded && (
                <LoadingScreen
                  text={"Loading. Please Wait..."}
                  transparent={true}
                  isLoaded={isLoaded}
                />
              )}
            </>
          )}
       
    </>
  );
};

const GemWalletRegistration = ({ onCancel }) => {
  const { toggleModal, modalContent, isOpen, closeModal, openModal } =
    useModal();
  // const { themeColors } = useWebsiteTheme();
  const { validateUser } = useUser({});
  const [email, setEmail] = useState();
  const [invoice, setInvoice] = useState();
  const [status, setStatus] = useState("idle");
  const [response, setResponse] = useState({});
  const [isVLoaded, setVLoaded] = useState(true);
  const [userAddress, setAddress] = useState("");
  const [errMsg, setError] = useState();
  const [emailErr, setEmailError] = useState();
  const [msg, setMessage] = useState("");
  const [isLoaded, setLoaded] = useState(false);
  const [isOpened, setOpened] = useState(false);
  const [payload, setPayload] = useState();
  const [isSigned, setSigned] = useState(false);
  const [next, setNext] = useState(false);
  const [gravatarUrl, setGravatar] = useState();
  const { signup, logout, getGravatarInfo, setEligible, currentUser } =
    useAuth();
  const emailRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (invoice) {
      if (status === "success" && response !== false) {
        VerifySignIn(response);
      }
      if (status === "error") {
        setLoaded(false);
        setPayload();
        setError(
          response?.error
            ? response?.error
            : "The sign in has failed. Reload the page and try again",
        );
      }
    }
    return () => {};
  }, [status, invoice]);

  useEffect(() => {
    if (invoice) {
      getSignTxStatus(invoice, status, setStatus, setResponse);
    }
    return () => {};
  }, [invoice]);

  function handleInput(e) {
    setError();
    setEmail(e?.target.value);
    setEmailError();
    //emailRef.curr
    //console.log(emailRef.current.value)
    //console.log(hashEmail(e.target.value))
  }

  //Verify xumm payload sign in by user
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async (response) => {
    setVLoaded(false);
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    setEmailError();
    setEmail();
    /*  signInWithCustomToken(auth, response.token)
                .then((user) => {
                      navigate( "/home");
                })
                .catch((err) => {
                  //console.log(err);
                  setEmailError(err.message);
                  setVLoaded(true);
                }); */
    openModal();
    modalContent(
      <OptionModal
        heading={"Registration Successful"}
        additionalText={
          "Your wallet address has successfully signed up for the sonar muse platform."
        }
      >
        <HoverOption
          onClick={() => {
            navigate("/access/signin");
            closeModal();
            modalContent();
          }}
        >
          Sign In
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/store");
            closeModal();
            modalContent();
          }}
        >
          Music Store
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/eligibilityChecker");
            closeModal();
            modalContent();
          }}
        >
          Check Eligibility Status
        </HoverOption>
      </OptionModal>,
    );
    return;
  };

  const signUp = async (pl) => {
    isInstalled()
      .then(async (response) => {
        if (response.result.isInstalled) {
          return signTransaction(pl.payload)
            .then(async (r) => {
              if (r?.result.signature) {
                closeModal();
                modalContent();
                await updateSignTxStatus(pl.invoice, {
                  signature: r?.result.signature,
                  isOffChain: pl?.payload?.transaction?.memo ? true : false,
                  ...r?.result,
                  signed: true,
                });
              } else {
                setLoaded(false);
                setError("Transaction Failed. Please reload and Try again");
                await updateSignTxStatus(pl.invoice, {
                  signed: false,
                });
              }
            })
            .catch((err) => {
              console.error(err);
              setLoaded(false);
              setError(err);
            });
        } else {
          setError("No Wallet Found");
          setLoaded(false);
        }
      })
      .catch((err) => {
        console.error(err);
        setError(err);
        setLoaded(false);
      });
  };

  const handleConnect = () => {
    isInstalled()
      .then((response) => {
        if (response.result.isInstalled) {
          getAddress().then(async (response) => {
            if (response.result?.address) {
              return axios
                .post(`/api/xrpl/createTransaction`, {
                  email: email,
                  type: TRANSACTION_OPTIONS.SIGN_UP,
                  memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                  sender: response.result?.address,
                  txInfo: {
                    email: email,
                    memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                    type: TRANSACTION_OPTIONS.SIGN_UP,
                    sender: response.result?.address,
                  },
                  walletType: WALLET_TYPES.GEM_WALLET,
                })
                .then(async (res) => {
                  // Switch the modal content to the Signer
                  setPayload(res.data.payload);
                  setInvoice(res.data.invoice);
                  setLoaded(true);
                  setNext(true);
                  await signUp(res.data);
                })
                .catch((err) => {
                  console.error(err);
                  setLoaded(false);
                  setError("Something went wrong. Please reload and try again");
                });
            } else {
              setLoaded(false);
              setError("Something went wrong. Please reload and try again");
            }
          });
        } else {
          setLoaded(false);
          setError(
            "Wallet not installed. Please install wallet before executing transaction",
          );
        }
      })
      .catch((err) => {
        console.error(err);
        setLoaded(false);
        const errorMessage =
          err?.message ||
          "An unexpected error occurred during the transaction.";
        setError(errorMessage);
      });
  };

  const validateEmail = async () => {
    openModal();
    modalContent(<ModalLoadingScreen text={"Loading. Please Wait"} />);
    return axios
      .get(`/api/${hashEmail(email)}/validateUser`)
      .then((valid) => {
        if (!valid?.data?.exists) {
          modalContent(
            <OptionModal
              heading={"Continue with Registration?"}
              additionalText={`Clicking continue will direct you to signing a transaction which will link the following email address ${email} to your XRP wallet address.
        In order to access the platform in the future, this email address will have to be linked to the wallet address you sign up with `}
            >
              <HoverOption
                onClick={() => {
                  modalContent(
                    <ModalLoadingScreen text={"Loading. Please Wait"} />,
                  );
                  handleConnect();
                }}
              >
                Continue
              </HoverOption>
            </OptionModal>,
          );
        } else {
          setEmail();
          modalContent(
            <OptionModal
              heading={"Email Address Already Exists"}
              additionalText={
                "An account with this email address already exists. Please enter a different email address or Login"
              }
            >
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                }}
              >
                OK
              </HoverOption>
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                  navigate("/access/login");
                }}
              >
                Login
              </HoverOption>
            </OptionModal>,
          );
        }
      })
      .catch((err) => {
        console.error(err);
        modalContent(
          <OptionModal heading={"Something went wrong"}>
            <HoverOption
              onclick={() => {
                validateEmail();
              }}
            >
              Try Again
            </HoverOption>
          </OptionModal>,
        );
      });
  };

  const refreshPage = () => {
    localStorage.clear();
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
  };

  useEffect(() => {
    if (currentUser?.uid) {
      navigate("/home");
    } else{
    setNext(false);
    setLoaded(false);
    setPayload({});
    setOpened(false);
    setError("");}
    return () => {};
  }, []);

  //render the sign up forms
  return (
    <>
          {!next && (
            <FormWrap>
             <Card>
                  <FormGroup>
                    <FormLabel>Email Address</FormLabel>
                    <FormInput
                      onChange={handleInput}
                      placeholder="Email Address"
                      value={email}
                    />
                    <Small>
                      Note: This address will be linked to your XRP wallet
                      address
                    </Small>
                  </FormGroup>
                  {emailErr && <Text>{emailErr}</Text>}
                  <FormButton1
                    onClick={() => {
                      if (emailRegex.test(email)) {
                        return validateEmail();
                      } else {
                        setEmailError("Invalid email address");
                      }
                    }}
                  >
                    Continue
                  </FormButton1>

                  <Small>
                    New to web3 or the XRPL? Learn more about how to sign up{" "}
                    <TextRoute to="/faq"> here</TextRoute>
                  </Small>
                  <Small>
                    Already have an account?{" "}
                    <TextRoute to="/access/signin">Sign in</TextRoute>
                  </Small>
                </Card>
            </FormWrap>
          )}

          {next && (
            <>
              {" "}
              {isLoaded === true && getObjectLength(payload) > 0 && (
                <>
                  <Form action={(e) => e.preventDefault}>
                    <FormH1> Registration </FormH1>
                    <FormText
                      style={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                      }}
                    >
                      Please open your wallet to sign the transaction.
                    </FormText>
                    <FormText /* style={{ color: themeColors.accentColor }} */>
                      Keep this page open while signing.
                    </FormText>

                    {/* BUTTON (Acts as Manual Retry if auto-trigger missed) */}
                    <FormButton1
                      onClick={handleConnect}
                      disabled={status === "processing"}
                    >
                      {status === "processing"
                        ? "Processing..."
                        : "Retry Transaction"}
                      {/* isWaiting
                        ? "Transaction didn't pop up? Click to Retry"
                        : "Confirm & Sign" */}
                    </FormButton1>
                  </Form>
                </>
              )}
              {errMsg && !response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1 transparent={false} onClick={refreshPage}>
                        Reload
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {errMsg && response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1
                        transparent={false}
                        to="/access/signup"
                        onClick={() => {
                          setEmail();
                          setEmailError();
                          setNext(false);
                          setLoaded(false);
                          setPayload({});
                          setError();
                          setInvoice();
                          setStatus("idle");
                          setResponse();
                          setOpened(false);
                          setLoaded(false);
                        }}
                      >
                        Retry
                      </FormButton1>
                      <FormButton1 onClick={() => navigate("/")}>
                        Go Home
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {!errMsg && !isLoaded && (
                <LoadingScreen
                  text={"Loading. Please Wait..."}
                  transparent={true}
                  isLoaded={isLoaded}
                />
              )}
            </>
          )}
    </>
  );
};

const CrossMarkRegistration = ({ onCancel }) => {
  const { toggleModal, modalContent, isOpen, closeModal, openModal } =
    useModal();
  //const { themeColors } = useWebsiteTheme();
  const { validateUser } = useUser({});
  const [email, setEmail] = useState();
  const [invoice, setInvoice] = useState();
  const [status, setStatus] = useState("idle");
  const [response, setResponse] = useState({});
  const [isVLoaded, setVLoaded] = useState(true);
  const [userAddress, setAddress] = useState("");
  const [errMsg, setError] = useState();
  const [emailErr, setEmailError] = useState();
  const [msg, setMessage] = useState("");
  const [isLoaded, setLoaded] = useState(false);
  const [isOpened, setOpened] = useState(false);
  const [payload, setPayload] = useState();
  const [isSigned, setSigned] = useState(false);
  const [next, setNext] = useState(false);
  const [gravatarUrl, setGravatar] = useState();
  const { signup, logout, getGravatarInfo, setEligible, currentUser } =
    useAuth();
  const emailRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    if (invoice) {
      if (status === "success" && response !== false) {
        VerifySignIn(response);
      }
      if (status === "error") {
        setLoaded(false);
        setPayload();
        setError(
          response?.error
            ? response?.error
            : "The sign in has failed. Reload the page and try again",
        );
      }
    }
    return () => {};
  }, [status, invoice]);

  useEffect(() => {
    if (invoice) {
      getSignTxStatus(invoice, status, setStatus, setResponse);
    }
    return () => {};
  }, [invoice]);

  function handleInput(e) {
    setError();
    setEmail(e?.target.value);
    setEmailError();
    //emailRef.curr
    //console.log(emailRef.current.value)
    //console.log(hashEmail(e.target.value))
  }

  //Verify xumm payload sign in by user
  //Get users XRP address info (Email Hash and Account Data)
  const VerifySignIn = async (response) => {
    setVLoaded(false);
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setResponse();
    setOpened(false);
    setLoaded(false);
    setEmailError();
    setEmail();
    /*  signInWithCustomToken(auth, response.token)
                .then((user) => {
                      navigate( "/home");
                })
                .catch((err) => {
                  //console.log(err);
                  setEmailError(err.message);
                  setVLoaded(true);
                }); */
    openModal();
    modalContent(
      <OptionModal
        heading={"Registration Successful"}
        additionalText={
          "Your wallet address has successfully signed up for the sonar muse platform."
        }
      >
        <HoverOption
          onClick={() => {
            navigate("/access/signin");
            closeModal();
            modalContent();
          }}
        >
          Sign In
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/store");
            closeModal();
            modalContent();
          }}
        >
          Music Store
        </HoverOption>
        <HoverOption
          onClick={() => {
            navigate("/eligibilityChecker");
            closeModal();
            modalContent();
          }}
        >
          Check Eligibility Status
        </HoverOption>
      </OptionModal>,
    );
    return;
  };

  const signUp = async (pl) => {
    await sdk.async
      .signAndSubmitAndWait(pl.payload)
      .then(async ({ request, response, createdAt, resolvedAt }) => {
        if (response?.data) {
          setLoaded(false);
          return await updateSignTxStatus(pl.invoice, {
            signature: response?.data?.signature,
            isOffChain: pl?.payload?.memo ? true : false,
            ...response.data,
            signed: true,
          });
        } else {
          setLoaded(false);
          setError("Transaction Failed. Please reload and Try again");
          await updateSignTxStatus(pl.invoice, {
            signed: false,
          });
        }
      })
      .catch((err) => {
        setLoaded(false);
        const errorMessage =
          err?.message ||
          "An unexpected error occurred during the transaction.";
        setError(errorMessage);
      });
  };

  const handleConnect = async () => {
    let isInstalled = await sdk.sync.isInstalled();
    if (isInstalled) {
      await sdk.methods
        .signInAndWait()
        .then(({ request, response, createdAt, resolvedAt }) => {
          if (response?.data?.address) {
            return axios
              .post(`/api/xrpl/createTransaction`, {
                email: email,
                type: TRANSACTION_OPTIONS.SIGN_UP,
                memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                sender: response.data?.address,
                publicKey: response?.data.publicKey,
                txInfo: {
                  email: email,
                  memo: "User is signing the following transaction to sign up for the Sonar Muse platform",
                  type: TRANSACTION_OPTIONS.SIGN_UP,
                  sender: response.data?.address,
                  publicKey: response?.data.publicKey,
                },
                walletType: WALLET_TYPES.CROSSMARK,
              })
              .then(async (res) => {
                // Switch the modal content to the Signer
                setPayload(res.data.payload);
                setInvoice(res.data.invoice);
                setLoaded(true);
                setNext(true);
                await signUp(res.data);
              })
              .catch((err) => {
                console.error(err);
                setError("Something went wrong. Please reload and try again");
              });
          }
        });
    } else {
      setLoaded(false);
      setError(
        "Wallet not installed. Please install wallet before executing transaction",
      );
    }
  };

  const validateEmail = async () => {
    openModal();
    modalContent(<ModalLoadingScreen text={"Loading. Please Wait"} />);
    return axios
      .get(`/api/${hashEmail(email)}/validateUser`)
      .then((valid) => {
        if (!valid?.data?.exists) {
          modalContent(
            <OptionModal
              heading={"Continue with Registration?"}
              additionalText={`Clicking continue will direct you to signing a transaction which will link the following email address ${email} to your XRP wallet address.
        In order to access the platform in the future, this email address will have to be linked to the wallet address you sign up with `}
            >
              <HoverOption
                onClick={() => {
                  modalContent(
                    <ModalLoadingScreen text={"Loading. Please Wait"} />,
                  );
                  handleConnect();
                }}
              >
                Continue
              </HoverOption>
            </OptionModal>,
          );
        } else {
          setEmail();
          modalContent(
            <OptionModal
              heading={"Email Address Already Exists"}
              additionalText={
                "An account with this email address already exists. Please enter a different email address or Login"
              }
            >
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                }}
              >
                OK
              </HoverOption>
              <HoverOption
                onClick={() => {
                  closeModal();
                  modalContent();
                  navigate("/access/login");
                }}
              >
                Login
              </HoverOption>
            </OptionModal>,
          );
        }
      })
      .catch((err) => {
        console.error(err);
        modalContent(
          <OptionModal heading={"Something went wrong"}>
            <HoverOption
              onclick={() => {
                validateEmail();
              }}
            >
              Try Again
            </HoverOption>
          </OptionModal>,
        );
      });
  };

  const refreshPage = () => {
    localStorage.clear();
    setPayload({});
    setError();
    setInvoice();
    setStatus("idle");
    setNext(false);
    setResponse();
    setOpened(false);
    setLoaded(false);
  };

  useEffect(() => {
     if (currentUser?.uid) {
      navigate("/home");
    }else{
    setNext(false);
    setLoaded(false);
    setPayload({});
    setOpened(false);
    setError("");}
    return () => {};
  }, []);

  //render the sign up forms
  return (
    <>
     
          {!next && (
            <FormWrap>
              <Card>
                  <FormGroup>
                    <FormLabel>Email Address</FormLabel>
                    <FormInput
                      onChange={handleInput}
                      placeholder="Email Address"
                      value={email}
                    />
                    <Small>
                      Note: This address will be linked to your XRP wallet
                      address
                    </Small>
                  </FormGroup>
                  {emailErr && <Text>{emailErr}</Text>}
                  <FormButton1
                    onClick={() => {
                      if (emailRegex.test(email)) {
                        return validateEmail();
                      } else {
                        setEmailError("Invalid email address");
                      }
                    }}
                  >
                    Continue
                  </FormButton1>

                  <Small>
                    New to web3 or the XRPL? Learn more about how to sign up{" "}
                    <TextRoute to="/faq"> here</TextRoute>
                  </Small>
                  <Small>
                    Already have an account?{" "}
                    <TextRoute to="/access/signin">Sign in</TextRoute>
                  </Small>
                </Card>
            </FormWrap>
          )}

          {next && (
            <>
              {" "}
              {isLoaded === true && getObjectLength(payload) > 0 && (
                <>
                  <Form action={(e) => e.preventDefault}>
                    <FormH1> Registration </FormH1>
                    <FormText
                      style={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                      }}
                    >
                      Please open your wallet to sign the transaction.
                    </FormText>
                    <FormText /* style={{ color: themeColors.accentColor }} */>
                      Keep this page open while signing.
                    </FormText>

                    {/* BUTTON (Acts as Manual Retry if auto-trigger missed) */}
                    <FormButton1
                      onClick={handleConnect}
                      disabled={status === "processing"}
                    >
                      {status === "processing"
                        ? "Processing..."
                        : "Retry Transaction"}
                      {/* isWaiting
                        ? "Transaction didn't pop up? Click to Retry"
                        : "Confirm & Sign" */}
                    </FormButton1>
                  </Form>
                </>
              )}
              {errMsg && !response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1 transparent={false} onClick={refreshPage}>
                        Reload
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {errMsg && response?.error && (
                <FormWrap>
                  <FormContent>
                    <Form>
                      <Text>{errMsg}</Text>
                      <FormButton1
                        transparent={false}
                        to="/signup"
                        onClick={() => {
                          setEmail();
                          setEmailError();
                          setNext(false);
                          setLoaded(false);
                          setPayload({});
                          setError();
                          setInvoice();
                          setStatus("idle");
                          setResponse();
                          setOpened(false);
                          setLoaded(false);
                        }}
                      >
                        Retry
                      </FormButton1>
                      <FormButton1 onClick={() => navigate("/")}>
                        Go Home
                      </FormButton1>
                    </Form>
                  </FormContent>
                </FormWrap>
              )}
              {!errMsg && !isLoaded && (
                <LoadingScreen
                  text={"Loading. Please Wait..."}
                  transparent={true}
                  isLoaded={isLoaded}
                />
              )}
            </>
          )}
    </>
  );
};

export default SignUpPage;
